import { getSplashTheme } from "@/lib/splashThemes";
import { SplashWordAnimation } from "./SplashWordAnimation";

export const SplashPreview = ({ themeId, compact = false }) => {
  const theme = getSplashTheme(themeId);
  return <div className={`splash-preview splash-theme-${theme.id} ${compact ? "splash-preview-compact" : ""}`} data-testid={`splash-preview-${theme.id}`}><SplashWordAnimation themeId={theme.id} compact={compact} /><p className="splash-preview-motto">{theme.motto}</p></div>;
};